/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface QuestionnairesXmlPostParams {
      body?: {

/**
 * The file which should be converted to a Questionnaire entity
 */
'XmlFile'?: Blob;

/**
 * The guid of the account to which this questionnaire belongs
 */
'AccountGuid'?: string;
}
}

export function questionnairesXmlPost(http: HttpClient, rootUrl: string, params: QuestionnairesXmlPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, questionnairesXmlPost.PATH, 'post');
  for (let headerKey of headers.keys()) {
      rb.header(headerKey, headers.get(headerKey));
  }
  rb.body(params.body, 'multipart/form-data');

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

questionnairesXmlPost.PATH = '/api/v1/questionnaires/xml';
